// src/models/ClienteDTO.js
class ClienteDTO { 
    
    constructor(data = {}){
        this.cdCliente = data.cdCliente;
        this.digitoCliente = data.digitoCliente;
        this.razaoSocial = data.razaoSocial;
        this.cnpj = data.cnpj;
        this.horarioLimitePedido1 = data.horarioLimitePedido1;
        this.horarioLimitePedido2 = data.horarioLimitePedido2;
        this.prazoPagamento = data.prazoPagamento;
        this.cdEmpresaPadrao = data.cdEmpresaPadrao;
        this.dsEmpresaPadrao = data.dsEmpresaPadrao;
        this.vencimentoAlvara = data.vencimentoAlvara;
        this.bloqueiaRetinoico = data.bloqueiaRetinoico;
        this.vlMinimoPrimeiroPedido = data.vlMinimoPrimeiroPedido;
        this.vlMinimoOutrosPedido = data.vlMinimoOutrosPedido;
        this.minimoAtivo = data.minimoAtivo;
        this.limite = data.limite;
        this.saldoDisponivel = data.saldoDisponivel;
        this.emails = data.emails;
        this.telefones = data.telefones;
        this.agrupaBoleto = data.agrupaBoleto;
        this.boletoDigital = data.boletoDigital;
        this.afe = data.afe;
        this.antecipado = data.antecipado;
    }
}

export default ClienteDTO;
